import React from 'react';
import ReactSelect from 'react-select';
import {ValueType} from 'react-select/lib/types';

import {select} from '../styles';
import {Label} from 'components/ultra';

import {ActivityType} from 'gql/types';

interface Option {
  value: ActivityType;
  label: string;
}

interface ActivityTypesProps {
  options: ActivityType[];
  value: ActivityType[];
  onChange(value: ActivityType[]): void;
}

export function ActivityTypesSelect({
  options,
  value,
  onChange,
}: ActivityTypesProps) {
  const formatOptions = (values: ActivityType[]) =>
    values.map(option => ({
      value: option,
      label: option.replace(/_/i, ' ').toLowerCase(),
    }));

  const formattedOptions = formatOptions(options);
  const formattedValue = value ? formatOptions(value) : null;

  // Guard for making sure it is not an Array but an object of type Option
  const isOption = (option: any): option is Option =>
    option.value !== undefined && option.label !== undefined;

  const handleChange = (option: ValueType<Option>) => {
    if (!isOption(option)) {
      onChange(option.map(item => item.value));
    }
  };

  return (
    <>
      <Label>Activities</Label>
      <ReactSelect
        isMulti
        options={formattedOptions}
        placeholder="Select activity types"
        value={formattedValue}
        onChange={handleChange}
        styles={select}
      />
    </>
  );
}
